// src/redux/alertSlice.ts
// 代替機械
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertColor } from '@mui/material/Alert';
import cloneDeep from "lodash/cloneDeep";

type AlertProp = {
    severity:AlertColor;
    message:string;
    displayTime:number
}
type AlertState = {
  alertList:AlertProp[];
}

// 初期値
const initialState:AlertState = {
  alertList : []
}

export const alertSlice = createSlice({
  name: 'alert',
  initialState, 
  reducers: {
    // アラートを追加
    appendAlert: (state, action: PayloadAction<AlertProp>) => {
      const workAlertProp = cloneDeep(action.payload);
      workAlertProp.displayTime = Date.now() + workAlertProp.displayTime;
      state.alertList = [...state.alertList, workAlertProp];
    },
    // 先頭のアラートを削除
    removeAlert: (state) => {
      if (state.alertList.length > 0) {
        // 要素の先頭を削除
        state.alertList = cloneDeep(state.alertList.slice(1));
      }
    },
    // Index指定したアラートを削除
    removeIndexAlert: (state, action: PayloadAction<number>) => {
      const newAlertList = cloneDeep(state.alertList);
      newAlertList.splice(action.payload, 1);
      state.alertList = newAlertList

    },
    // 指定時間超過したアラートを削除
    removeTimeTrigger: (state, action: PayloadAction<number>) => {
      state.alertList = cloneDeep(state.alertList).filter(d => d.displayTime > action.payload);
    }
  },
});

const { appendAlert, removeAlert, removeIndexAlert, removeTimeTrigger } = alertSlice.actions;
export { appendAlert, removeAlert, removeIndexAlert, removeTimeTrigger }
export default alertSlice.reducer;